export default [
  {
    title: 'modules.toolbox.toolbox', /* <i18n path="modules.toolbox.toolbox"></i18n> */
    icon: 'FileTextIcon',
    children: [],
  },
]
